import { useEffect, useState } from "react";
import { asAgentSearchApi } from "../api/asAgentSearchApi";
import { useDispatch, useSelector } from "react-redux";
import {
  findAgent,
  findMoreAgent,
} from "../../../modules/reducers/afterService/afterServiceAgent";
import useReactGASend from "../../../hooks/useReactGASend";

const useAsAgentSearch = () => {
  const { makeEventTrackFn } = useReactGASend();

  const infinity = useSelector((state) => state.afterServiceAgent.infinity);
  const agentList = useSelector((state) => state.afterServiceAgent.agentList);
  const loading = useSelector((state) => state.afterServiceAgent.loading);
  const loaded = useSelector((state) => state.afterServiceAgent.loaded);

  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    keyword: "",
    g_code: "1000",
    req_page: 1,
  });
  const [activeTab, setActiveTab] = useState("가전");

  const categories = {
    가전: 1000,
    생활: 3000,
    완구: 2000,
    기타: 4000,
  };
  const categoryKeys = Object.keys(categories);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      req_page: 1,
    }));
  };

  useEffect(() => {}, [formData]);
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setFormData((prev) => ({
      ...prev,
      g_code: categories[tab],
      req_page: 1,
    }));
    clearInput();
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };

  const clearInput = () => {
    setFormData((prev) => ({
      ...prev,
      keyword: "",
      req_page: 1,
    }));
  };
  const search = () => {
    const api = asAgentSearchApi(
      formData.keyword,
      formData.g_code,
      formData.req_page
    );
    dispatch(findAgent(api));
    setFormData((prev) => ({
      ...prev,
      req_page: prev.req_page + 1,
    }));
  };

  const fetchMoreData = () => {
    const api = asAgentSearchApi(
      formData.keyword,
      formData.g_code,
      formData.req_page
    );
    dispatch(findMoreAgent(api));
    setFormData((prev) => ({
      ...prev,
      req_page: prev.req_page + 1,
    }));
  };

  useEffect(() => {
    search();
  }, []);

  useEffect(() => {
    search();
  }, [formData.g_code, formData.keyword]);

  return {
    formData,
    handleChange,
    search,
    activeTab,
    handleTabClick,
    categoryKeys,
    clearInput,
    infinity,
    agentList,
    fetchMoreData,
    loading,
    loaded,
  };
};

export default useAsAgentSearch;
